import { Button, styled } from "@mui/material";
import { Add, Remove, ShoppingCart } from "@mui/icons-material";
// LOCAL CUSTOM COMPONENTS
import { FlexAlignCenter } from "./FlexBox";

// STYLED COMPONENTS
const ButtonContainer = styled("div")({
  width: 160,
  display: "flex",
  justifyContent: "space-between"
});

const ProductPrice = styled(FlexAlignCenter)(({ theme }) => ({
  width: 160,
  flexGrow: "1",
  background: theme.palette.background.paper
}));

export default function AddToCartButton({
  color,
  amount,
  propStyle,
  totalUnit,
  handleAddCart,
  handleRemoveCart
}) {
  return (
    <div>
      {amount === 0 && (
        <Button sx={propStyle} variant="contained" color="primary" onClick={handleAddCart}>
          <ShoppingCart fontSize="small" sx={{ mr: 1 }} />
          Add To Cart
        </Button>
      )}

      {amount > 0 && (
        <ButtonContainer sx={propStyle}>
          <Button
            size="small"
            color="primary"
            variant="contained"
            sx={{ p: 1, minWidth: 32 }}
            onClick={handleRemoveCart}>
            <Remove fontSize="small" />
          </Button>

          <ProductPrice>{amount}</ProductPrice>

          <Button
            size="small"
            color="primary"
            variant="contained"
            onClick={handleAddCart}
            sx={{ p: 1, minWidth: 32 }}
            disabled={amount === totalUnit}>
            <Add fontSize="small" />
          </Button>
        </ButtonContainer>
      )}
    </div>
  );
}
